import { t } from "@/i18n-js/instance";
import { ConfirmButton } from "@circle-react/components/LiveStreams/common/ConfirmButton";
import { ScreenFrame } from "@circle-react/components/LiveStreams/common/ScreenFrame";
import { Typography } from "@circle-react-uikit/Typography";

export const StreamIsFull = () => {
  const handleOnClick = () => {
    window.location.reload();
  };

  return (
    <ScreenFrame>
      <div className="flex max-w-lg flex-col items-center justify-center gap-6">
        <div className="text-5xl leading-tight">
          {t("live_streams.public.landing.disappointed")}
        </div>
        <Typography.TitleXl color="text-white">
          {t("live_streams.public.landing.full_title")}
        </Typography.TitleXl>
        <Typography.BodyMd color="text-gray-400" textAlign="text-center">
          {t("live_streams.public.landing.full_description")}
        </Typography.BodyMd>
        <ConfirmButton onClick={handleOnClick}>{t("retry")}</ConfirmButton>
      </div>
    </ScreenFrame>
  );
};
